<template>
  <div class="product-list" data-testid="global-allocation-product-list">
    <div class="product-list__header">
      <div class="product-list__header-division">
        <BulletAsset
          class="product-list__header-bullet"
          :color="product.typeColor"
        />
        <Heading :level="4">
          {{ product.investmentClassType.formatted }}
        </Heading>
      </div>
      <Heading :level="4">
        {{ product.allocPercentage.formatted }}
      </Heading>
    </div>
    <ul v-if="products.length" class="product-list__list">
      <li v-for="(item, index) in products" :key="index">
        <ProductAllocationCard
          data-testid="global-allocation-product-card"
          :is-clickable="isClickable(item)"
          :product-name="item.name"
          :product-allocation="item.allocPercentage.formatted"
          :product-total-balance="item.totalBalance.formatted"
          :aria-label="`Ver detalhes do produto ${item.name}`"
          @onclick="() => openProductDetailsModal(item)"
        />
      </li>
    </ul>
    <Row v-else>
      <template #top-left>Não há ativos.</template>
    </Row>
    <ProductDetails
      :is-open="productModalOpen"
      :instrument="selectedInstrument"
      hide-right-button
      :is-unavailable-instrument="false"
      show-product-quotas
      @close="closeProductDetailsModal"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Heading, Row } from '@warrenbrasil/nebraska-web';
import { BulletAsset } from '@/modules/common/components/BulletAsset';
import { ProductAllocationCard } from '@/modules/common/components/cards/ProductAllocationCard';
import { ProductDetails } from '@/modules/products/components/ProductDetails';
import {
  IAllocationProducts,
  IProducts
} from '@/modules/products/services/investments';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
@Component({
  components: {
    BulletAsset,
    Heading,
    Row,
    ProductDetails,
    ProductAllocationCard
  }
})
export default class GlobalAllocationProductList extends Vue {
  readonly NebraskaColors = NebraskaColors;
  @Prop({ type: Object, required: true })
  readonly product!: IAllocationProducts;

  productModalOpen = false;
  selectedInstrument = { apiId: '' };
  get products() {
    return this.product.products;
  }

  isClickable(item: IProducts) {
    return !!item.id;
  }

  openProductDetailsModal(item: IProducts) {
    this.productModalOpen = true;
    this.selectedInstrument.apiId = item.id;
  }

  closeProductDetailsModal() {
    this.productModalOpen = false;
    this.selectedInstrument.apiId = '';
  }
}
</script>

<style lang="less" scoped>
.product-list {
  &__header {
    display: flex;
    justify-content: space-between;
    margin-bottom: @size-spacing-x300;
    &-division {
      display: flex;
      align-items: center;
    }
    &-bullet {
      margin-right: @size-spacing-x300;
    }
  }
  &__list {
    list-style: none;
    padding: 0;
  }
}
</style>
